// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== ESTILOS PARA CARACTERÍSTICAS DEL INMUEBLE ===== */

/* Asegurar que no haya overflow hidden en contenedores padre */
:host {
  overflow: visible !important;
  display: block !important;
}

:host * {
  overflow: visible !important;
}


/* Contenedor principal de características */
.property-features {
  background: #fff;
  border-radius: 12px;
  padding: 3rem 1.5rem 1.5rem 1.5rem !important;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: visible !important;
}

.features-content {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.8rem;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible !important;
  position: relative;
  z-index: 1;
}

@media (max-width: 768px) {
  .features-content {
    flex-wrap: wrap;
    gap: 0.6rem;
    justify-content: space-between;
  }
  
  .feature-item {
    flex: 1 1 calc(50% - 0.3rem);
    min-width: 120px;
    max-width: none;
  }
  
  .add-button-item {
    flex: 1 1 calc(50% - 0.3rem);
    min-width: 120px;
  }
}

.feature-item {
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative;
  min-width: 100px;
  max-width: none;
  overflow: visible !important;
  z-index: 1;
  pointer-events: auto;
}

/* Asegurar que el primer elemento no tenga problemas de z-index */
.feature-item:first-child {
  z-index: 2;
  pointer-events: auto !important;
}

.feature-item:first-child .feature-box {
  z-index: 2;
  pointer-events: auto !important;
}

.feature-item:first-child .dark-grey-box {
  z-index: 200;
  pointer-events: auto !important;
}

.feature-item:first-child .feature-input {
  z-index: 10000 !important;
  pointer-events: auto !important;
  position: relative !important;
}

.feature-box {
  background: #e9ecef;
  border-radius: 12px;
  padding: 0.75rem;
  width: 100%;
  min-height: 90px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1.2rem;
  transition: all 0.2s ease;
  pointer-events: auto;
  z-index: 1;
}

.feature-box:hover {
  background: #e0e6ea;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.dark-grey-box {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 0.5rem;
  width: 90%;
  min-height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.5rem;
  position: relative;
  z-index: 100;
  pointer-events: auto;
}

.icon-above {
  position: absolute !important;
  top: -35px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 36px !important;
  height: 36px !important;
  background: #ffffff !important;
  border-radius: 50% !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15) !important;
  border: 2px solid #f09502 !important;
  overflow: visible !important;
  pointer-events: none !important;
  user-select: none !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  /* Asegurar que el icono no bloquee nada */
  touch-action: none !important;
}

/* Asegurar que el icono del primer elemento no bloquee */
.feature-item:first-child .icon-above {
  z-index: 0 !important;
  pointer-events: none !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}

.add-button-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-width: 100px;
  max-width: none;
}

.add-feature-btn {
  background: #f09502;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-top: 0.5rem;
  height: 40px;
  width: 100%;
  justify-content: center;
  max-width: 120px;
}

.add-feature-btn:hover {
  background: #e08502;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(240, 149, 2, 0.3);
}

.add-feature-btn i {
  font-size: 1rem;
}

.feature-icon {
  color: #f09502;
  font-size: 1.3rem;
  font-weight: bold;
  display: block;
  line-height: 1;
}

.feature-label {
  font-size: 0.8rem;
  color: #333;
  text-align: center;
  font-weight: 600;
  margin: 0;
  margin-bottom: 0.3rem;
  text-transform: capitalize;
}

/* Estilos para inputs y checkboxes en los campos */
.feature-input {
  width: 100%;
  max-width: 60px;
  padding: 0.4rem 0.5rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.8rem;
  text-align: center;
  background: white;
  transition: all 0.2s ease;
  position: relative;
  z-index: 10000 !important;
  pointer-events: auto !important;
  cursor: text;
  appearance: textfield;
}

/* Asegurar que los spinners del input number sean clickeables */
.feature-input::-webkit-inner-spin-button,
.feature-input::-webkit-outer-spin-button {
  opacity: 1;
  pointer-events: auto;
  cursor: pointer;
  height: auto;
}

.feature-input:focus {
  outline: none;
  border-color: #f09502;
  box-shadow: 0 0 0 2px rgba(240, 149, 2, 0.2);
  transform: scale(1.05);
}

.feature-input:hover {
  border-color: #f09502;
}

.checkbox-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  background: white;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  border: 1px solid #ddd;
  transition: all 0.2s ease;
}

.checkbox-container:hover {
  border-color: #f09502;
  background: #fff8f0;
}

.feature-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #f09502;
  cursor: pointer;
}

.checkbox-label {
  font-size: 0.75rem;
  color: #333;
  margin: 0;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/* Modal de selección de campos */
.field-selector-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.field-selector-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.field-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
}

.field-selector-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.2rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: #f0f0f0;
  color: #333;
}

.field-selector-body {
  padding: 1.5rem;
  padding-bottom: 2.5rem; /* Extra padding to prevent bottom items from getting cut off */
  max-height: 60vh; /* Increased to give more room */
  overflow-y: auto; /* Allow scrolling within the body */
}

.available-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.field-option {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 2px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
}

.field-option:hover {
  border-color: #f09502;
  background: #fff8f0;
}

.field-option.selected {
  border-color: #f09502;
  background: #fff8f0;
}

.field-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.field-option-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
  width: 30px;
  text-align: center;
}

.field-option-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.field-option-name {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.field-option-type {
  font-size: 0.8rem;
  color: #666;
}

.field-option-checkbox {
  margin-left: 1rem;
}

.field-option-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #f09502;
}

.field-selector-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem;
  border-top: 1px solid #eee;
  background: #f8f9fa;
}

.btn-secondary {
  padding: 0.75rem 1.5rem;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  background: #f8f9fa;
  border-color: #ccc;
}

.btn-primary {
  padding: 0.75rem 1.5rem;
  background: #f09502;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.btn-primary:hover {
  background: #e08502;
}

/* Mejoras adicionales para los campos */
.feature-item {
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-2px);
}

/* Estilos para campos vacíos */
.feature-input:placeholder-shown {
  background: #f8f9fa;
  color: #6c757d;
}

.feature-input:not(:placeholder-shown) {
  background: white;
  color: #333;
  font-weight: 500;
}

/* Animación para checkboxes */
.feature-checkbox:checked + .checkbox-label {
  color: #f09502;
  font-weight: 600;
}

/* Mejora del icono */
.feature-icon {
  font-size: 1.3rem;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.feature-item:hover .feature-icon {
  transform: scale(1.1);
  color: #e08502;
}

.feature-item:hover .icon-above {
  border-color: #e08502;
  box-shadow: 0 4px 15px rgba(240, 149, 2, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-property-features/new-project-property-features.component.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D,+DAA+D;AAC/D;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,sCAAsC;EACtC,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,qDAAqD;EACrD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA,yDAAyD;AACzD;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,YAAY;EAGZ,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;;EAEE,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB,EAAE,+DAA+D;EACvF,gBAAgB,EAAE,gCAAgC;EAClD,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":["/* ===== ESTILOS PARA CARACTERÍSTICAS DEL INMUEBLE ===== */\n\n/* Asegurar que no haya overflow hidden en contenedores padre */\n:host {\n  overflow: visible !important;\n  display: block !important;\n}\n\n:host * {\n  overflow: visible !important;\n}\n\n\n/* Contenedor principal de características */\n.property-features {\n  background: #fff;\n  border-radius: 12px;\n  padding: 3rem 1.5rem 1.5rem 1.5rem !important;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: visible !important;\n}\n\n.features-content {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.8rem;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: visible !important;\n  position: relative;\n  z-index: 1;\n}\n\n@media (max-width: 768px) {\n  .features-content {\n    flex-wrap: wrap;\n    gap: 0.6rem;\n    justify-content: space-between;\n  }\n  \n  .feature-item {\n    flex: 1 1 calc(50% - 0.3rem);\n    min-width: 120px;\n    max-width: none;\n  }\n  \n  .add-button-item {\n    flex: 1 1 calc(50% - 0.3rem);\n    min-width: 120px;\n  }\n}\n\n.feature-item {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  min-width: 100px;\n  max-width: none;\n  overflow: visible !important;\n  z-index: 1;\n  pointer-events: auto;\n}\n\n/* Asegurar que el primer elemento no tenga problemas de z-index */\n.feature-item:first-child {\n  z-index: 2;\n  pointer-events: auto !important;\n}\n\n.feature-item:first-child .feature-box {\n  z-index: 2;\n  pointer-events: auto !important;\n}\n\n.feature-item:first-child .dark-grey-box {\n  z-index: 200;\n  pointer-events: auto !important;\n}\n\n.feature-item:first-child .feature-input {\n  z-index: 10000 !important;\n  pointer-events: auto !important;\n  position: relative !important;\n}\n\n.feature-box {\n  background: #e9ecef;\n  border-radius: 12px;\n  padding: 0.75rem;\n  width: 100%;\n  min-height: 90px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1.2rem;\n  transition: all 0.2s ease;\n  pointer-events: auto;\n  z-index: 1;\n}\n\n.feature-box:hover {\n  background: #e0e6ea;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.dark-grey-box {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 0.5rem;\n  width: 90%;\n  min-height: 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 0.5rem;\n  position: relative;\n  z-index: 100;\n  pointer-events: auto;\n}\n\n.icon-above {\n  position: absolute !important;\n  top: -35px !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  z-index: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 36px !important;\n  height: 36px !important;\n  background: #ffffff !important;\n  border-radius: 50% !important;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15) !important;\n  border: 2px solid #f09502 !important;\n  overflow: visible !important;\n  pointer-events: none !important;\n  user-select: none !important;\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  /* Asegurar que el icono no bloquee nada */\n  touch-action: none !important;\n}\n\n/* Asegurar que el icono del primer elemento no bloquee */\n.feature-item:first-child .icon-above {\n  z-index: 0 !important;\n  pointer-events: none !important;\n  user-select: none !important;\n}\n\n.add-button-item {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-width: 100px;\n  max-width: none;\n}\n\n.add-feature-btn {\n  background: #f09502;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.5rem 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  margin-top: 0.5rem;\n  height: 40px;\n  width: 100%;\n  justify-content: center;\n  max-width: 120px;\n}\n\n.add-feature-btn:hover {\n  background: #e08502;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(240, 149, 2, 0.3);\n}\n\n.add-feature-btn i {\n  font-size: 1rem;\n}\n\n.feature-icon {\n  color: #f09502;\n  font-size: 1.3rem;\n  font-weight: bold;\n  display: block;\n  line-height: 1;\n}\n\n.feature-label {\n  font-size: 0.8rem;\n  color: #333;\n  text-align: center;\n  font-weight: 600;\n  margin: 0;\n  margin-bottom: 0.3rem;\n  text-transform: capitalize;\n}\n\n/* Estilos para inputs y checkboxes en los campos */\n.feature-input {\n  width: 100%;\n  max-width: 60px;\n  padding: 0.4rem 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  text-align: center;\n  background: white;\n  transition: all 0.2s ease;\n  position: relative;\n  z-index: 10000 !important;\n  pointer-events: auto !important;\n  cursor: text;\n  -webkit-appearance: textfield;\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n/* Asegurar que los spinners del input number sean clickeables */\n.feature-input::-webkit-inner-spin-button,\n.feature-input::-webkit-outer-spin-button {\n  opacity: 1;\n  pointer-events: auto;\n  cursor: pointer;\n  height: auto;\n}\n\n.feature-input:focus {\n  outline: none;\n  border-color: #f09502;\n  box-shadow: 0 0 0 2px rgba(240, 149, 2, 0.2);\n  transform: scale(1.05);\n}\n\n.feature-input:hover {\n  border-color: #f09502;\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  background: white;\n  padding: 0.3rem 0.6rem;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  transition: all 0.2s ease;\n}\n\n.checkbox-container:hover {\n  border-color: #f09502;\n  background: #fff8f0;\n}\n\n.feature-checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: #f09502;\n  cursor: pointer;\n}\n\n.checkbox-label {\n  font-size: 0.75rem;\n  color: #333;\n  margin: 0;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n\n/* Modal de selección de campos */\n.field-selector-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.field-selector-content {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.field-selector-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid #eee;\n  background: #f8f9fa;\n}\n\n.field-selector-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.2rem;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #666;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.field-selector-body {\n  padding: 1.5rem;\n  padding-bottom: 2.5rem; /* Extra padding to prevent bottom items from getting cut off */\n  max-height: 60vh; /* Increased to give more room */\n  overflow-y: auto; /* Allow scrolling within the body */\n}\n\n.available-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.field-option {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  border: 2px solid #eee;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.field-option:hover {\n  border-color: #f09502;\n  background: #fff8f0;\n}\n\n.field-option.selected {\n  border-color: #f09502;\n  background: #fff8f0;\n}\n\n.field-option.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.field-option-icon {\n  font-size: 1.5rem;\n  margin-right: 1rem;\n  width: 30px;\n  text-align: center;\n}\n\n.field-option-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.field-option-name {\n  font-weight: 500;\n  color: #333;\n  font-size: 0.9rem;\n}\n\n.field-option-type {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.field-option-checkbox {\n  margin-left: 1rem;\n}\n\n.field-option-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #f09502;\n}\n\n.field-selector-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding: 1.5rem;\n  border-top: 1px solid #eee;\n  background: #f8f9fa;\n}\n\n.btn-secondary {\n  padding: 0.75rem 1.5rem;\n  border: 1px solid #ddd;\n  background: white;\n  color: #666;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n}\n\n.btn-secondary:hover {\n  background: #f8f9fa;\n  border-color: #ccc;\n}\n\n.btn-primary {\n  padding: 0.75rem 1.5rem;\n  background: #f09502;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n}\n\n.btn-primary:hover {\n  background: #e08502;\n}\n\n/* Mejoras adicionales para los campos */\n.feature-item {\n  transition: all 0.3s ease;\n}\n\n.feature-item:hover {\n  transform: translateY(-2px);\n}\n\n/* Estilos para campos vacíos */\n.feature-input:placeholder-shown {\n  background: #f8f9fa;\n  color: #6c757d;\n}\n\n.feature-input:not(:placeholder-shown) {\n  background: white;\n  color: #333;\n  font-weight: 500;\n}\n\n/* Animación para checkboxes */\n.feature-checkbox:checked + .checkbox-label {\n  color: #f09502;\n  font-weight: 600;\n}\n\n/* Mejora del icono */\n.feature-icon {\n  font-size: 1.3rem;\n  transition: all 0.2s ease;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.feature-item:hover .feature-icon {\n  transform: scale(1.1);\n  color: #e08502;\n}\n\n.feature-item:hover .icon-above {\n  border-color: #e08502;\n  box-shadow: 0 4px 15px rgba(240, 149, 2, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
